import { BASE_API_URL } from '../env';
import { getToken } from '../service/CookieManager';

const LOGIN_URL = '/admin/login';

type METHOD = 'GET' | 'POST' | 'PUT' | 'DELETE' | 'PATCH';
const HEADERS = {
  'Content-Type': 'application/json',
  Accept: 'application/json',
};
const HEADERS_DOWNLOAD = {
  Accept:
    'text/html,application/xhtml+xml,application/xml;q=0.9,image/avif,image/webp,image/apng,*/*;q=0.8,application/signed-exchange;v=b3;q=0.9',
};

export const getParams = (params: any) => {
  if (!!params && typeof params === 'object' && params !== null) {
    const queryParts: string[] = [];
    Object.keys(params).forEach(k => {
      const value = params[k];
      if (Array.isArray(value)) {
        // Handle arrays by repeating the parameter name for each value
        value.forEach(v => {
          queryParts.push(`${encodeURIComponent(k)}=${encodeURIComponent(v)}`);
        });
      } else if (value !== null && value !== undefined && value !== '') {
        queryParts.push(`${encodeURIComponent(k)}=${encodeURIComponent(value)}`);
      }
    });
    return queryParts.length > 0 ? `?${queryParts.join('&')}` : '';
  }
  return '';
};

export const Method = {
  DOWNLOAD: 'downloadAPI',
  FETCH: 'fetch',
};

const callApi = (
  url: string,
  method: METHOD,
  body: any = null,
  queryParams: any = null,
  header: any = {},
  type = Method.FETCH
) => {
  console.log('API Call - URL:', url);
  console.log('API Call - Method:', method);
  console.log('API Call - Body:', body);
  console.log('API Call - Query Params:', queryParams);

  const token = getToken(url);
  // Ensure proper URL construction with slashes
  const baseUrl = BASE_API_URL || '';
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanUrlPath = url.startsWith('/') ? url : `/${url}`;

  const newUrl = queryParams
    ? `${cleanBaseUrl}${cleanUrlPath}${getParams(queryParams)}`
    : `${cleanBaseUrl}${cleanUrlPath}`;

  console.log('API Call - Full URL:', newUrl);
  console.log('API Call - Token:', token);

  const headers = {
    ...(type === Method.DOWNLOAD ? HEADERS_DOWNLOAD : HEADERS),
    ...header,
  };
  if (url !== LOGIN_URL) {
    headers.Authorization = `Bearer ${token}`;
  }

  console.log('API Call - Headers:', headers);

  const options: any = {
    method,
    headers,
  };

  if (body) {
    options.body = JSON.stringify(body);
  }

  console.log('API Call - Options:', options);

  return fetch(newUrl, options).then(
    async response => {
      console.log('API Response Status:', response.status);

      // For download requests, handle both success (blob) and error (JSON) responses
      if (type === Method.DOWNLOAD) {
        const _contentType = response.headers.get('content-type') || '';
        const httpStatusOk = response.status >= 200 && response.status < 300;

        // If error status, try to parse as JSON to get error message
        if (!httpStatusOk) {
          try {
            const errorData = await response.json();
            return {
              data: errorData,
              status: false,
              statusCode: response.status,
            };
          } catch {
            // If JSON parsing fails, return blob anyway
            const blobData = await response.blob();
            return {
              data: blobData,
              status: false,
              statusCode: response.status,
            };
          }
        }

        // Success response - return blob
        const blobData = await response.blob();
        return {
          data: blobData,
          status: true,
          statusCode: response.status,
        };
      }

      // For regular API calls, check both HTTP status and backend isSuccess field
      return response.json().then(data => {
        console.log('API Response Data:', data);

        const httpStatusOk = response.status >= 200 && response.status < 300;
        const backendSuccess = data?.isSuccess === 1;
        const isSuccess = httpStatusOk && backendSuccess;

        return {
          data,
          status: isSuccess,
          statusCode: response.status,
        };
      });
    },
    err => {
      console.error('API Call Error:', err);
      return err;
    }
  );
};

export const uploadImageApiCall = async (
  url: string,
  formData: any,
  method: 'POST' | 'PUT' = 'POST'
) => {
  const token = getToken(url);
  // Ensure proper URL construction with slashes
  const baseUrl = BASE_API_URL || '';
  const cleanBaseUrl = baseUrl.endsWith('/') ? baseUrl.slice(0, -1) : baseUrl;
  const cleanUrlPath = url.startsWith('/') ? url : `/${url}`;

  const data = await fetch(`${cleanBaseUrl}${cleanUrlPath}`, {
    method,
    headers: {
      Authorization: `Bearer ${token}`,
      // Don't set Content-Type header - browser will set it automatically with boundary for multipart/form-data
    },
    body: formData,
  });
  return await data.json();
};

export const downloadSalesReport = (response: any) => {
  if (response?.status) {
    const url = window.URL.createObjectURL(new Blob([response.data]));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', `${'SalesReport'}.pdf`);
    document.body.appendChild(link);
    link.click();
  }
};

export default callApi;
